<template>
  <div id="app">
    <el-container>
      <!-- header 顶部 -->
      <el-header style="height:50px;padding:0px;min-width:800px;" v-if="isShow">
        <Header   ref="heads" ></Header>
      </el-header>
      <el-container class="wrap">
        <!-- aside 侧边栏 -->
        <el-aside width="200px" style="background-color:#112955;overflow: auto;" v-if="isShow">
          <Aside class="aside_menu"></Aside>
        </el-aside>
        <el-container>
          <!-- main 主体显示部分 -->
          <el-main style="overflow:auto;">
            <Breadcrumb :v-if="isB"></Breadcrumb>
            <div class="contaner_box" :class="{'contaner_box_index': !isTop}">
              <router-view class="home-container" ref="routerViewer" v-on:loaded="routerViewLoaded"    @execut="executeheadermethod"   />
            </div>
          </el-main>
          <!-- footer 底部 -->
          <el-footer v-if="false" style="height:40px;background:#fff;text-align:center;font-size:16px;color:#000;line-height:40px;">&copy;版权所有&nbsp;高信达信息科技有限公司</el-footer>
        </el-container>
      </el-container>
    </el-container>
    <audio height="100" width="100" id="promptTone" style="margin-left: 200px;display: none;">
      <source :src="'../static/promptTone.mp3'">
      <source :src="'../static/promptTone.wav'">
      <source :src="'../static/promptTone.ogg'">
      <embed height="50" width="100" :src="'../static/promptTone.mp3'">
    </audio>
  </div>
</template>
<script>
import Header from "./components/header.vue";
import Aside from "./components/aside.vue";
import Breadcrumb from "./components/breadcrumb.vue";
export default {
  name: "App",
  data() {
    return {
      isShow: true,
      isTop: true,
      keyword: "",
      tempKeyword: "",
      isB: true,
      agentNoticeTimer: 0,
    };
  },
  components: {
    Header, //顶部header组件
    Aside, //左边侧边栏菜单
    Breadcrumb //面包屑导航
  },
  mounted() {
    this.getNewNoticeFn();
    let name = this.$route.name.toLowerCase();
      if (name == "home") {
        this.isTop = false;
      } else {
        this.isTop = true;
      }
      if (name == "login") {
        this.isShow = false;
      } else if (name == "forgetpswd") {
        this.isShow = false;
      } else {
        this.isShow = true;
      }
  },
  created() {
    
  },
  methods: {

    //调用headr的方法

    executeheadermethod(){

        this.$refs.heads.QryNotReadSiteLetterList(true);
    },
    getNewNoticeFn(){ // 是否有新的通知记录
      if (this.$store.state.islogin) { // 已登录
        var UserCode = this.getLocalStorage("userInfo").UserCode;
        var agentNoticeCount = this.getLocalStorage(UserCode + "agentNoticeCount"); // 缓存中之前记录条数
        // console.log(agentNoticeCount);
        if (typeof agentNoticeCount == "number") { 
          if (!this.$store.state.whetherNewNoticeCharge) { // 没有新通知标识时, 再去请求
            this.$loginapi.postWithPage( "/Notice/GetAgentNoticeList",
              1,
              1,
              "",
              response => {
                if (response.Ret == 0) {
                  var newAgentNoticeCount = response.Pager.RecordCount;
                  // console.log(newAgentNoticeCount);
                  if (newAgentNoticeCount > agentNoticeCount) { // 有新的通知记录
                    this.$store.state.whetherNewNoticeCharge = true;
                    var audioDom = document.getElementById('promptTone'); 
                    audioDom.play();
                  }
                } else {
                  //this.$message.error(response.Msg);
                  // this.$alert(response.Msg, {});
                }
              }
            );
          }
        }
      }
      clearTimeout(this.agentNoticeTimer);
      this.agentNoticeTimer = setTimeout( () => {
        this.getNewNoticeFn();
      }, 30000);
    },
    getLocalStorage(name) {
      var val = JSON.parse(localStorage.getItem(name));
      return val;
    },
    //当路由嵌入视图加载完成后触发
    routerViewLoaded(route) {
      console.log(route.params)
      if (this.$refs.routerViewer.loaded) {
        if (route.params && JSON.stringify(route.params) != "{}") {
          //alert("5");
          route.params.loadingByGlobalQuery = false;
          this.$refs.routerViewer.loaded(route.params);
        }
      }
    }
  },
  watch: {
    "$route": 'checkLogin',
    $route: function(newroute, oldroute) {
      let name = newroute.name.toLowerCase();
      if (name == "home") {
        this.isTop = false;
      } else {
        this.isTop = true;
      }
      if (name == "login") {
        this.isShow = false;
      } else if (name == "forgetpswd") {
        this.isShow = false;
      } else {
        this.isShow = true;
      }
    }
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/App.vue